export default {
  title_one: 'Estatísticas de entrega a atualizar para "{{title}}"',
  title_other: 'Estatísticas de entrega a atualizar para {{count}} campanhas',
  subtitle_pending:
    'Apple e Google confirmam as receções em cerca de {{minutes}}m {{seconds}}s (por volta das {{time}}). As estatísticas serão atualizadas automaticamente.',
  subtitle_ready: 'As receções devem ter chegado. Atualize a página para ver os números de entrega mais recentes.',
};
